import "./NavBarAppMenu.css";

import { Button } from "../../buttons/Button";
import { TextButton } from '../../buttons/TextButton';
import { ConfigurationProvider } from '../../../infrastructure/configuration/ConfigurationProvider';
import { INavBarAppMenuItem, orbitalWatchApps, orbitalWatchEnvironment } from '../orbitalWatchApps';
import { useNavigate } from 'react-router-dom';

interface INavBarAppMenuProps {
    onClose: () => any;
}
// Suite apps (Ark, Aurora, Vision, Atlas, Identity, Pulsar) on this environment's hosts:
// QA builds and laptops link to https://<app>.qa.orbitalwatch.dev, prod to the prod hosts.
// Pulsar is prod-only, so outside prod it links to prod as "Pulsar (prod)".
function appMenuItems(): INavBarAppMenuItem[] {
    const env = orbitalWatchEnvironment(ConfigurationProvider.getConfiguration()?.App?.BackendUrl);
    return [
        ...orbitalWatchApps(env),
        { label: "Devops", href: "https://dev.azure.com/n4it-Enterprise-Solutions/" },
    ];
}

export function NavBarAppMenu(props: INavBarAppMenuProps) {

    const navigate = useNavigate();


    return (
        <div className="nav-bar-app-menu">
            {appMenuItems().map((item) => (
                <TextButton key={item.label} text={item.label} className="nav-bar-btn" type="white" onClick={() => { props.onClose(); window.open(item.href); }} />
            ))}
        </div>
    )
}